import React from "react";
import styles from "./index.module.css";

const VehicleCardSkeleton = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.image}></div>
      <div className={styles.price}></div>
      <div className={styles.name}></div>
      <div className={styles.info}></div>
      <hr />
      <div className={styles.carStats}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default VehicleCardSkeleton;
